module.exports = __webpack_public_path__ + "static/media/receivers.221f4b56.svg";